import React from 'react';
import DashboardComponent from '../components/dashboardComopnenet/dashboardComopnenet';

export default function Dashboard() {

    return <DashboardComponent />;
}